const FILTER_TYPE = {
    EMAIL: 'EMAIL',
    STAR: 'STAR',
    CHECK: 'CHECK',
    IMAGE: 'IMAGE',
    FILE: 'FILE',
    NOTE: "NOTE",
    META_URL: "META_URL",
    TEXT: "TEXT",
    TEXT_SOLO: "TEXT_SOLO",
    FILE_SOLO: 'FILE_SOLO',
    IMAGE_SOLO: 'IMAGE_SOLO',
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    AUDIO_SOLO: 'AUDIO_SOLO',
};

export default FILTER_TYPE;
